import React from 'react';

const Avatar = ({ image, size = 45, avgColor = '#ccc' }) => {
  const styles = {
    width: size,
    height: size,
    borderRadius: size / 2,
    WebkitBorderRadius: size / 2,
    MozBorderRadius: size / 2,
    backgroundColor: avgColor,
    overflow: 'hidden',
    display: 'inline-block',
    padding: 0,
    margin: 0,
  };

  return (
    <div style={styles}>
      <img src={image} style={{ width: '100%', height: '100%' }} alt="Twine" />
    </div>
  );
};

export default Avatar;
